import React from "react";
import { Instagram, Mail, MapPin } from "lucide-react";
import { SOCIALS, buildWhatsAppLink } from "../constants";
import Logo from "./Logo";

const TikTokIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="currentColor"
    {...props}
  >
    <path d="M12.5 2h3a.5.5 0 0 1 .5.5c0 2.49 2.01 4.5 4.5 4.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5 7.46 7.46 0 0 1-4.5-1.5v6.5a6.5 6.5 0 1 1-6.5-6.5.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5 2.5 2.5 0 1 0 2.5 2.5V2.5a.5.5 0 0 1 .5-.5Z" />
  </svg>
);

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-ink text-cream pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size="lg" variant="light"/>
            <p className="mt-6 max-w-sm text-sm leading-relaxed">
              Marca venezolana de ropa personalizada inspirada en la fe, la
              familia y la identidad. Hecho con propósito por Naiderly Marquez.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={SOCIALS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full border border-page/20 flex items-center justify-center hover:bg-page hover:text-ink transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href={SOCIALS.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                data-testid="footer-tiktok"
                className="w-10 h-10 rounded-full border border-page/20 flex items-center justify-center hover:bg-page hover:text-ink transition-colors"
              >
                <TikTokIcon />
              </a>
              <a
                href={buildWhatsAppLink("Hola, quiero más información de Vallitas.")}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-full bg-[#25D366] text-white flex items-center justify-center hover:scale-105 transition-transform"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M20.52 3.48A11.93 11.93 0 0 0 12.05 0C5.5 0 .15 5.34.15 11.9c0 2.1.55 4.14 1.6 5.95L0 24l6.32-1.66a11.86 11.86 0 0 0 5.73 1.46h.01c6.55 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.17-3.44-8.42ZM12.06 21.5h-.01a9.6 9.6 0 0 1-4.9-1.34l-.35-.21-3.75.98 1-3.65-.23-.37a9.57 9.57 0 0 1-1.47-5.11c0-5.31 4.32-9.63 9.63-9.63a9.55 9.55 0 0 1 6.81 2.83 9.55 9.55 0 0 1 2.82 6.8c0 5.32-4.32 9.7-9.55 9.7Zm5.27-7.18c-.29-.14-1.7-.84-1.97-.94-.26-.1-.45-.14-.64.14-.19.28-.74.94-.91 1.13-.17.19-.34.21-.62.07-.29-.14-1.21-.45-2.3-1.42-.85-.76-1.42-1.7-1.59-1.98-.17-.29-.02-.44.13-.58.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.64-1.55-.88-2.12-.23-.55-.46-.48-.64-.49l-.55-.01c-.19 0-.5.07-.76.36-.26.29-1 1-1 2.43 0 1.43 1.03 2.81 1.17 3 .14.19 2.02 3.08 4.9 4.32.69.3 1.22.48 1.64.61.69.22 1.31.19 1.81.12.55-.08 1.7-.7 1.94-1.37.24-.67.24-1.24.17-1.37-.07-.13-.26-.21-.55-.34Z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-gold mb-4">
              Explora
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="#propuesta" className="hover:text-page transition-colors">Propuesta</a></li>
              <li><a href="#productos" className="hover:text-page transition-colors">Productos</a></li>
              <li><a href="#como-funciona" className="hover:text-page transition-colors">Cómo funciona</a></li>
              <li><a href="#historia" className="hover:text-page transition-colors">Historia</a></li>
              <li><a href="#b2b" className="hover:text-page transition-colors">Equipos B2B</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.25em] text-gold mb-4">
              Contacto
            </div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-gold" />
                <a
                  href="mailto:hola@vallitas.com"
                  data-testid="footer-email"
                  className="hover:text-page transition-colors"
                >
                  hola@vallitas.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[#B98363]" />
                <span>Valencia · Venezuela · Envíos nacionales</span>
              </li>
              <li>
                <a
                  href={buildWhatsAppLink("Hola Vallitas!")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-text"
                  className="inline-flex items-center gap-2 rounded-full bg-vino text-page px-5 py-2.5 text-sm font-medium hover:bg-vino-deep transition-colors"
                >
                  +58 414 358 1962
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-page/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gold">
          <p>© {new Date().getFullYear()} Vallitas. Todos los derechos reservados.</p>
          <p className="italic font-heading text-base text-cream">
            Vestimos historia, unimos familias.
          </p>
        </div>
      </div>
    </footer>
  );
}
